import { render, staticRenderFns } from "./generic-polygon.vue?vue&type=template&id=569da4a4&scoped=true&"
import script from "./generic-polygon.vue?vue&type=script&lang=js&"
export * from "./generic-polygon.vue?vue&type=script&lang=js&"
import style0 from "./generic-polygon.vue?vue&type=style&index=0&id=569da4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569da4a4",
  null
  
)

export default component.exports